module.exports = __webpack_public_path__ + "img/38.19691d5c.jpg";